import { Localized } from "@fluent/react";
import { Alert, Box, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from "@mui/material";
import { unwrapResult } from "@reduxjs/toolkit";
import { Fragment, useState } from "react";
import { AppId } from "../../../app/appTypes";
import { useAppDispatch } from "../../../app/hooks";
import { updateUrsField } from "../UrsSlice";
import { SaveButton } from "../../../app/components/SaveButton";
import { CloseButton } from "../../../app/components/CloseButton";
import { Help } from "../../dialogs/HelpDialog";


export interface EditUrsNumberingModeDialogProps {
    ursId: AppId;
    numberingMode: string;
    onSuccess: (newValue: string) => void
    onCancel: () => void;
}

export const EditUrsNumberingModeDialog = (props: EditUrsNumberingModeDialogProps) => {
    const dispatch = useAppDispatch();
    const [saving, setSaving] = useState(false);
    const [numberingMode, setNumberingMode] = useState<string>(props.numberingMode);
    const [serverError, setServerError] = useState("");


    const handleNumberingModeChange = (value) => {
        setNumberingMode(value);
        setServerError("");
    };

    const getServerErrorMessage = (error: unknown) => {
        if (error && typeof error === "object") {
            const apiError = error as {
                kind?: string
                problem?: { title?: string }
            }

            if (apiError.kind === "http" && apiError.problem?.title) {
                return apiError.problem.title
            }
        }

        return "error"
    }

    const handleOkClick = () => {
        setSaving(true)
        setServerError("")
        dispatch(updateUrsField({
            ursId: props.ursId,
            fieldName: "documentnumberingmode",
            text: numberingMode as string
        }))
            .then(unwrapResult)
            .then(() => { props.onSuccess(numberingMode) })
            .catch(err => {
                console.error(err)
                setServerError(getServerErrorMessage(err))
            })
            .finally(() => {
                setSaving(false)
            })
    }

    return (
        <Dialog open={true} fullWidth maxWidth="xs">
            <DialogTitle
                sx={{
                    bgcolor: (theme) => theme.palette.grey[200],
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    py: 0.75,
                }}
            >
                <Localized id="edit">Edycja</Localized>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ marginTop: 2 }}>
                    <TextField
                        value={numberingMode}
                        fullWidth
                        select
                        label={<Fragment>
                            <Localized id="urs-numbering-method">Sposób numerowania  </Localized>
                            <Help id="7e0300fb-e1cf-4810-aab7-183f5e68d975" />
                        </Fragment>
                        }
                        onChange={e => handleNumberingModeChange(e.target.value)}
                    >
                        <MenuItem value={"UNIQUE_REQ"}><Localized id="urs-unique"><span>Unikalne</span></Localized></MenuItem>
                        <MenuItem value={"DECIMAL_HIERARCHICAL"}><Localized id="urs-hierarchical"><span>Hierarchiczne</span></Localized></MenuItem>
                    </TextField>
                    {serverError && <Alert sx={{ marginTop: 1 }} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>}
                </Box>
            </DialogContent>
            <DialogActions>
                <SaveButton loading={saving} onClick={handleOkClick} />
                <CloseButton loading={saving} onClick={props.onCancel} />
            </DialogActions>
        </Dialog>
    );
};
